export default __webpack_public_path__ + "static/media/bg.06252be5.jpg";